module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "response-container"
  }, [_c('h1', [_vm._v("ICEGATE 06 API Response")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("SB No (5444772)"), _c('b-badge', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "light",
      "title": "Shipping Bill Number"
    }
  }, [_vm._v("?")])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sbNo),
      expression: "sbNo"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "e.g. 5444772"
    },
    domProps: {
      "value": (_vm.sbNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sbNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("SB Date(16092011) "), _c('b-badge', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "light",
      "title": "Format: DDMMYYYY"
    }
  }, [_vm._v("?")])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sbDt),
      expression: "sbDt"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "e.g. 16092011"
    },
    domProps: {
      "value": (_vm.sbDt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sbDt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-col', {
    staticClass: "align-self-end",
    attrs: {
      "md": "3"
    }
  }, [(_vm.sbNo && _vm.sbDt) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getAllICEGATE06Func()
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "search"
    }
  }), _vm._v(" Fetch\n        ")], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.errorMsg) ? _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": ""
    }
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && (_vm.sbNo && _vm.sbDt) && (_vm.getAllICEGATE06.leoDt)) ? _c('b-card', {
    staticClass: "mt-4 shadow"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "6"
    }
  }, [_c('b', [_vm._v("SB No:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getAllICEGATE06.sbNo || (_vm.getAllICEGATE06.leoDt) || _vm.sbNo))]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "size": "sm",
      "variant": "outline-secondary",
      "title": "Copy SB No"
    },
    on: {
      "click": function($event) {
        _vm.copyToClipboard(_vm.getAllICEGATE06.sbNo || (_vm.getAllICEGATE06.data && _vm.getAllICEGATE06.data.sbNo))
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "clipboard"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "6"
    }
  }, [_c('b', [_vm._v("SB Date:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getAllICEGATE06.sbDt || (_vm.getAllICEGATE06.leoDt) || _vm.sbDt))])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "6"
    }
  }, [_c('b', [_vm._v("LEO Date:")]), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !(_vm.getAllICEGATE06.leoDt || _vm.leoDtDisplay)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getAllICEGATE06.leoDt || _vm.leoDtDisplay || 'N/A') + "\n          ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && (_vm.sbNo && _vm.sbDt) && !(_vm.getAllICEGATE06)) ? _c('b-alert', {
    staticClass: "mt-4",
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("\n      No LEO Date found for this SB No and Date.\n    ")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f745e67","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ulip/ICEGATE06_ResponseDisplay.vue
// module id = 2549
// module chunks = 0